import React from 'react';
import { useRouter } from 'next/router';

import { ApplicationLinkAction } from '@internal/components/application-view/application-progress';
import ApplicationStateBanner from '@internal/components/application-view/application-state-banner';
import {
  getApplicationTargetHref,
  useApplicationModel,
} from '@internal/components/application-view/use-application-model';
import {
  getApplicationHref,
  hasSubmittedApplication,
} from '@internal/components/projects/helper/application-state';
import { PROJECT_FROM_QUERY_KEY } from '@internal/components/projects/helper/projects.helpers';
import { Profile } from '@internal/types/profile';
import { Project } from '@internal/types/projects';

interface ProjectApplicationBannerProps {
  project: Project;
  profile: Profile;
  onSummary: () => void;
}

const ProjectApplicationBanner: React.FC<ProjectApplicationBannerProps> = ({
  project,
  profile,
  onSummary,
}) => {
  const router = useRouter();
  const { model, roleProgress } = useApplicationModel(project, profile);

  if (!model) return null;

  const navigate = (href: string) => {
    router.push(href).catch(() => {});
  };
  const runAction = (action: ApplicationLinkAction) =>
    navigate(
      getApplicationTargetHref(action.target, project, roleProgress?.role?.id)
    );

  return (
    <ApplicationStateBanner
      banner={model.banner}
      showSummary={hasSubmittedApplication(project)}
      onSummary={onSummary}
      onAction={runAction}
      fallbackAction={{
        label: 'Go to application',
        onClick: () =>
          navigate(
            getApplicationHref(project, router.query[PROJECT_FROM_QUERY_KEY])
          ),
      }}
    />
  );
};

export default ProjectApplicationBanner;
